module.exports = __webpack_public_path__ + "img/dark-green-square-table-1.86ff896b.png";